export default {
  title:       'Gestão dos meus dados',
  description: 'Portabilidade dos dados',
};
